import { Component } from '@angular/core';

@Component({
    selector: 'app-em-construcao',
    templateUrl: './em-construcao.component.html',
    styleUrls: ['./em-construcao.component.css']
})

export class EmConstrucaoComponent {
}
